export enum NotProdIntegrataEnum {
    DOMANDA_INIZIALE = 'DOMANDA_INIZIALE',
    CONFERMA = 'CONFERMA',
    RETTIFICA = 'RETTIFICA',
}

export enum CohesionType {
    TERRENI = "TERRENI",
    TRASFORMAZIONE_CONFEZIONAMENTO = "TRASFORMAZIONE_CONFEZIONAMENTO",
    INTERMEDIAZIONE = "INTERMEDIAZIONE",
    COMMERCIALIZZAZIONE_PRODOTTO_SFUSO = "COMMERCIALIZZAZIONE_PRODOTTO_SFUSO"
}

export enum NotProdIntegrataScopoEnum {
    ACA = "ACA",
    MARCHIO_SQNPI = "MARCHIO_SQNPI",
    MARCHIO_SQNPI_E_ACA = "MARCHIO_SQNPI_E_ACA",
}

export interface filtersDTO {
    itemsPerPage: number
    page: number
    order?: boolean
    sort?: string
    active?: boolean
}

export interface NotSQNPIDTOResponse {
    page: string
    data: NotSQNPIDTO[]
}

export interface NotSQNPIDTO {
    id: string
    customerId: string
    type: string
    region: string
    number: string
    protocol: string
    campaignYear: string
    protocolDate: Date
    adhesionDate: Date
    purpose: string
    regionalMark: boolean
    adhesionTypes: CohesionType[]
    sqnpiNotificationConfirmationId: string
    sqnpiNotificationRectificationId: string
    requestProtocolId: string
    note: string
}

export interface CreateNotSQNPIDTO {
    customerId: string
    type?: string
    campaignYear?: string
    region?: string
    number?: string
    protocol?: string
    protocolDate?: Date
    adhesionDate?: Date
    purpose?: string
    regionalMark?: boolean
    adhesionTypes?: string[]
    sqnpiNotificationConfirmationId?: string
    sqnpiNotificationRectificationId?: string
    requestProtocolId?: string
    note?: string
}

export interface UpdateNotSQNPIDTO {
    customerId: string
    type?: string
    campaignYear?: string
    region?: string
    number?: string
    protocol?: string
    protocolDate?: Date
    adhesionDate?: Date
    purpose?: string
    regionalMark?: boolean
    adhesionTypes?: CohesionType[]
    sqnpiNotificationConfirmationId?: string
    sqnpiNotificationRectificationId?: string
    requestProtocolId?: string
    note?: string
}